export default {
  name: 'custom_textarea_field',
  component_path: 'modules/procedures/blocks/BlockInputTextarea'
}